import { Modal } from 'src/ui/Modal';
import { UserPickerPanel } from 'src/ui/patterns/UserPickerPanel';
import { UserEntity } from 'src/store/userApi';

interface UserPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedUserId?: string;
  onUserSelect: (user: UserEntity | null) => void;
}

/** Modal wrapper using the shared UserPickerPanel for picking who to chat as. */
const UserPickerModal = ({
  isOpen,
  onClose,
  selectedUserId,
  onUserSelect,
}: UserPickerModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Pick a user to chat as"
      subtitle="You will impersonate this member in the matchmaker chat."
      width={460}
    >
      <div style={{ height: 460, display: 'flex', flexDirection: 'column' }}>
        <UserPickerPanel
          selectedUserId={selectedUserId}
          title="Users"
          height={460}
          onSelect={(user) => {
            onUserSelect(user);
            onClose();
          }}
        />
      </div>
    </Modal>
  );
};

export default UserPickerModal;
